<!-- Top bar -->
<div class="app-topbar">
  <div class="app-topbar-start">
    <button pButton type="button" icon="pi pi-bars" class="p-button-text p-button-rounded hamburger-btn"
      (click)="toggleSidebar()" aria-label="Menú"></button>
    <img src="./assets/Bild-Portal.svg" height="40" class="mr-2" [routerLink]="isMobile ? '/mobile/menu' : null" />
  </div>
  <div class="app-topbar-end">
    <p-menu #menu [model]="profileItems" [popup]="true"></p-menu>
    @if (userDetails) {
      <div>
        <div style="display: flex; flex-direction: column; align-items: flex-start;">
          <p-button [label]="userDetails.email" size="small" icon="pi pi-user" [text]="true"
            (click)="menu.toggle($event)">
          </p-button>
          <span class="role-label">{{ userDetails.role?.name }}</span> <!-- Rol alineado debajo del icono -->
        </div>
      </div>
    } @else {
      <ng-template [ngTemplateOutlet]="null"></ng-template>
    }
  </div>
</div>

<!-- Navigation drawer -->
<p-drawer [(visible)]="sidebarVisible" position="left" [modal]="true" [showCloseIcon]="false"
  [maskStyle]="{ background: 'transparent !important' }" (onShow)="resetMenuExpansion()"
  [pt]="{ header: { style: { display: 'none' } } }"
  [style]="{ top: 'var(--app-topbar-height)', height: 'calc(100% - var(--app-topbar-height))' }">
  <ng-template #menuList let-items="items" let-level="level">
    @for (item of items; track item.label) {
      @if (item.visible !== false) {
        <li class="menu-node">
          @if (level === 1 && item.items?.length) {
            <!-- Root-level sections ("Administración", "Gestión de Inventarios") are
                 static: always expanded, not a click-to-collapse toggle. -->
            <div class="menu-row menu-row--static">
              @if (item.icon) {
                <i class="menu-row-icon" [ngClass]="item.icon"></i>
              }
              <span class="menu-row-label">{{ item.label }}</span>
            </div>
            <ul class="menu-children">
              <ng-container *ngTemplateOutlet="menuList; context: { items: item.items, level: level + 1 }"></ng-container>
            </ul>
          } @else {
            <a class="menu-row" [routerLink]="item.routerLink ?? null" tabindex="0"
              (click)="onMenuItemClick(item, $event)" (keydown.enter)="onMenuItemClick(item, $event)"
              (keydown.space)="onMenuItemClick(item, $event)">
              @if (item.icon) {
                <i class="menu-row-icon" [ngClass]="item.icon"></i>
              }
              <span class="menu-row-label">{{ item.label }}</span>
              @if (item.items?.length) {
                <i class="menu-row-chevron pi pi-chevron-right" [class.menu-row-chevron--open]="item.expanded"></i>
              }
            </a>
            @if (item.items?.length) {
              <div class="menu-children-wrapper" [class.menu-children-wrapper--open]="item.expanded">
                <div class="menu-children-inner">
                  <ul class="menu-children">
                    <ng-container *ngTemplateOutlet="menuList; context: { items: item.items, level: level + 1 }"></ng-container>
                  </ul>
                </div>
              </div>
            }
          }
        </li>
      }
    }
  </ng-template>

  <nav class="sidebar-menu" aria-label="Menú principal">
    <ul class="menu-root">
      <ng-container *ngTemplateOutlet="menuList; context: { items: menuItems, level: 1 }"></ng-container>
    </ul>
    <div class="menu-divider"></div>
    <button type="button" class="menu-row" (click)="themeService.toggleDarkMode()">
      <i class="menu-row-icon pi" [ngClass]="themeService.isDarkMode ? 'pi-sun' : 'pi-moon'"></i>
      <span class="menu-row-label">{{ themeService.isDarkMode ? 'Modo claro' : 'Modo oscuro' }}</span>
    </button>
  </nav>
</p-drawer>

<p-toast></p-toast>
<!-- Content section -->
<div class="app-content">
  <div style="flex-grow: 1; padding: 20px;">
    <router-outlet></router-outlet>
  </div>
  <!-- Footer section -->
  <footer class="footer">
    <div>
      <span>&copy; {{ currentYear }} Bild App. All Rights Reserved.</span>
    </div>
  </footer>
</div>
<!-- User profile edit-->
<app-user-profile [userProfileVisible]="userProfileVisible"
(userSidebarClosed)="resetUserProfileVisibility()"></app-user-profile>